import { Injectable } from '@angular/core';
import { ApiTopService } from '../api/api-top.service';
import { Observable, of } from 'rxjs';
import { HttpEvent } from '@angular/common/http';
import { ScannerApiService } from '../scanner/scanner-api.service';
import { HrvTestMeasurementResult } from '../../interfaces/biozoom-api/hrv-test-measurement-result';
import { StateInterface } from '../../interfaces/biozoom-api/app-configuration';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ScanHeartService {

  constructor(
    private apiTopService: ApiTopService,
    private scannerApiService: ScannerApiService
  ) { }

  getMeasurementTest = (state: StateInterface, oldApi: boolean) => {
    return this.scannerApiService.getMeasurement(state, 'hrv-test', oldApi);
  }
  getMeasurement = (state: StateInterface): Observable<HttpEvent<any>> => {
    return this.scannerApiService.getMeasurement(state, 'hrv');
  }

  initMeasurement = (state: StateInterface) => {
    // if (oldApi) {
    //   return this.scannerApiService.getMeasurement(state, 'hrv');
    // }
    // return this.scannerApiService.doHrvOfflineMeasurement(state, false, v2);
    return this.scannerApiService.getMeasurement(state, 'hrvOfflineDo');
  }

  getMeasurementResult = (state: StateInterface, v2: boolean) => {
    return this.scannerApiService.getMeasurement(state, 'hrvOfflineGet');
    // return this.scannerApiService.getHrvOfflineMeasurement(state, v2);
  }


  calculateMeasurementResultTest = (
    demoMode: boolean,
    language: string,
    serial: string,
    data: any,
    additionalData?: any
  ): Observable<HrvTestMeasurementResult> => {
    return this.apiTopService.executeMeasurementHrvTest(
      demoMode, serial, data, language, additionalData
    ).pipe(
      switchMap((el) => {
        return of(el);
      }),
    );
  }

  calculateMeasurementResult = (
    demoMode: boolean,
    language: string,
    serial: string,
    data: any,
    additionalData?: any,
    measurementType?: string
  ): Observable<HttpEvent<any>> => {
    return this.apiTopService.executeMeasurementHrv(
      demoMode, serial, data, language, additionalData, measurementType
    ).pipe(
      switchMap((el) => {
        return of(el);
      }),
    );
  }

  calculateMeasurementResultSingle = (
    demoMode: boolean,
    language: string,
    serial: string,
    data: any,
    additionalData?: any,
    measurementType?: string
  ): Observable<HttpEvent<any>> => {
    return this.apiTopService.executeMeasurementHrvSingle(
      demoMode, serial, data, language, additionalData, measurementType
    );
  }
}
